const point = "https://backend.bookify.kz"
const startpoint = `${point}`
const mediapoint = `${point}/`

export { point, startpoint, mediapoint }